import { Component, Input, OnInit } from '@angular/core';

import { ViewCell } from 'ng2-smart-table';

@Component({
  template: `
    <div style="font-weight: 450 !important; position: relative; top: 5px;">{{UpperText}}</div>
    <div *ngFor='let text of LowerText' style="font-size:11px !important; font-weight: 100 !important; position: relative; top: 5px; margin-top: 8px">{{text}}</div>
  `,
})
export class MultipleCellContentComponent implements ViewCell, OnInit {

  UpperText: string;
  LowerText: string[];

  @Input() value: string;
  @Input() rowData: any;

  ngOnInit() {
    // console.log(this.value);
    var newString = this.value.split('||');
    this.UpperText = newString.shift();
    this.LowerText = newString;
  }

}